window.__sizePromptUserSelected = false;

(() => {
  const SIZE_KEYS = ["rozmiar", "Rozmiar", "rozmir", "size", "Size"];
  const PROMPT_TEXT = "Wybierz rozmiar";
  const COLOR_KEYS = ["color", "kolor", "kolory"]; // какие названия опции цвета бывают у тебя

function isColorWrapper(el) {
  const label = el?.querySelector(".form__label, legend")?.innerText?.toLowerCase() || "";
  return COLOR_KEYS.some(k => label.includes(k));
}

function getColorControls() {
  // ищем группу опций, где подпись = цвет
  const wrappers = [...document.querySelectorAll(".product-form__input")].filter(isColorWrapper);
  // из неё берём интерактивы (radio/btn/select)
  const ctrls = wrappers.flatMap(w => [
    ...w.querySelectorAll('input[type="radio"], button, select')
  ]);
  return ctrls;
}
function bindColorListeners() {
  // чтобы не навесить по 10 раз
  getColorControls().forEach(ctrl => {
    if (ctrl.dataset.sizePromptColorBound === "1") return;
    ctrl.dataset.sizePromptColorBound = "1";
    ctrl.addEventListener("change", delayedInit); // триггерим placeholder ТОЛЬКО при смене цвета
  });
}


  function isSizeSelect(select) {
    const label = select.closest(".product-form__input")?.querySelector(".form__label")?.innerText?.toLowerCase() || "";
    return SIZE_KEYS.some(k => label.includes(k));
  }

  function resetToPlaceholder(select) {
    if (!select) return;

    // Удаляем старый placeholder, если есть
    const oldPh = select.querySelector("option[value='']");
    if (oldPh) oldPh.remove();

    // Создаем новый placeholder
    const placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.textContent = PROMPT_TEXT;
    placeholder.disabled = true;
    placeholder.selected = true;
    select.insertBefore(placeholder, select.firstChild);

    // Сбрасываем выбор на placeholder
    select.value = "";

// При выборе настоящего варианта placeholder снимается и больше не сбрасывается
select.addEventListener("change", () => {
  const ph = select.querySelector("option[value='']");
  if (ph && select.value !== "") {
    ph.removeAttribute("selected");
    // убираем фразу навсегда пока не сменили цвет
    window.__sizePromptUserSelected = true;
  }
});

  }

  function processAll() {
    console.log('[SIZE PROMPT] Processing selects...');
    document.querySelectorAll("select.select__select").forEach(select => {
if (isSizeSelect(select) && !window.__sizePromptUserSelected) {
  resetToPlaceholder(select);
}


    });
  }

  // Отложенный запуск — ждем пока Shopify закончит отрисовку
  function delayedInit() {
    clearTimeout(window.__sizePromptTimer);
    // Shopify пересобирает DOM с задержкой — ждём чуть дольше
    processAll();
  }

// эти события используем только чтобы перевесить слушатели на контролы цвета
["DOMContentLoaded", "variant:rebuild", "shopify:section:load"].forEach(evt =>
  document.addEventListener(evt, () => {
    bindColorListeners();   // навесили слушатели на color
    // delayedInit не дергаем тут — пусть срабатывает именно от смены цвета
  })
);


const observer = new MutationObserver(muts => {
  let touchedColor = false;
  for (const m of muts) {
    for (const n of m.addedNodes) {
      if (n.nodeType !== 1) continue;
      if (n.matches?.(".product-form__input") && isColorWrapper(n)) touchedColor = true;
      if (!touchedColor && n.querySelector?.(".product-form__input") && [...n.querySelectorAll(".product-form__input")].some(isColorWrapper)) touchedColor = true;
    }
  }

if (touchedColor) {
  bindColorListeners();
  requestAnimationFrame(() => delayedInit()); // мягко перестраиваем без скачка
  }
});
observer.observe(document.body, { childList: true, subtree: true });


  delayedInit();
})();

(() => {
  const BUTTON_SELECTOR = 'button[name="add"].product-form__submit';
  const SIZE_SELECTORS = ["rozmiar", "rozmir", "size"];
  const PROMPT_TEXT = "Wybierz rozmiar";

  function getSizeSelect() {
    const selects = document.querySelectorAll('select.select__select');
    for (const s of selects) {
      const label = s.closest(".product-form__input")?.querySelector(".form__label")?.innerText?.toLowerCase() || "";
      if (SIZE_SELECTORS.some(k => label.includes(k))) return s;
    }
    return null;
  }

  function checkSizeSelected() {
    const sel = getSizeSelect();
    if (!sel) return true;
    const text = sel.options[sel.selectedIndex]?.textContent?.trim()?.toLowerCase() || "";
    const val = sel.value?.trim() || "";
    return window.__sizePromptUserSelected === true || (val !== "" && !text.includes(PROMPT_TEXT.toLowerCase()));
  }

  function updateButtonState() {
    const btn = document.querySelector(BUTTON_SELECTOR);
    if (!btn) return;
    if (!checkSizeSelected()) {
      btn.disabled = true;
      btn.classList.add("blocked-add");
    } else {
      btn.disabled = false;
      btn.classList.remove("blocked-add");
    }
  }

  // обновляем состояние кнопки при каждом изменении
  document.addEventListener("change", updateButtonState);
  // убираем проверку при смене цвета, слушаем только изменения в selectах
document.querySelectorAll('select.select__select').forEach(sel => {
  sel.addEventListener('change', updateButtonState);
});

  document.addEventListener("DOMContentLoaded", updateButtonState);

  // и каждые 300 мс проверяем на случай пересоздания кнопки Shopify’ем
  setInterval(updateButtonState, 300);
})();
(() => {
  const BUTTON_SELECTOR = 'button[name="add"].product-form__submit';
  const SIZE_KEYS = ["rozmiar", "rozmir", "size"];
  const PROMPT_TEXT = "Wybierz rozmiar";
  const WARNING_TEXT = "Wybierz rozmiar, aby dodać produkt do koszyka";

  function getSizeSelect() {
    const selects = document.querySelectorAll('select.select__select');
    for (const s of selects) {
      const label = s.closest(".product-form__input")?.querySelector(".form__label")?.innerText?.toLowerCase() || "";
      if (SIZE_KEYS.some(k => label.includes(k))) return s;
    }
    return null;
  }

  function isSizeChosen() {
    const sel = getSizeSelect();
    if (!sel) return true;
    const text = sel.options[sel.selectedIndex]?.textContent?.trim()?.toLowerCase() || "";
    const val = sel.value?.trim() || "";
    return window.__sizePromptUserSelected === true || (val !== "" && !text.includes(PROMPT_TEXT.toLowerCase()));
  }

  function ensureWarningElement(form) {
    if (!form) return null;
    let msg = form.querySelector(".size-warning-msg");
    if (!msg) {
      msg = document.createElement("div");
      msg.className = "size-warning-msg";
      msg.textContent = WARNING_TEXT;
      Object.assign(msg.style, {
        color: "red",
        fontWeight: "600",
        fontSize: "0.95rem",
        marginTop: "8px",
        marginBottom: "8px",
        textAlign: "center",
      });
      const btn = form.querySelector(BUTTON_SELECTOR);
      if (btn) btn.insertAdjacentElement("beforebegin", msg);
    }
    return msg;
  }

  function updateButtonAndWarning() {
      // если кнопка не менялась по смыслу (например, Shopify просто пересоздал DOM)
  // и состояние не изменилось — выходим, ничего не трогаем
  const prevState = updateButtonAndWarning.__lastState;
  const currentState = isSizeChosen();
  if (prevState === currentState) return;
  updateButtonAndWarning.__lastState = currentState;

    const btn = document.querySelector(BUTTON_SELECTOR);
    if (!btn) return;
    const form = btn.closest("form") || document;
    const msg = ensureWarningElement(form);

    if (!isSizeChosen()) {
      btn.disabled = true;
      btn.classList.add("blocked-add");
      msg.style.display = "block";
    } else {
      btn.disabled = false;
      btn.classList.remove("blocked-add");
      msg.style.display = "none";
    }
  }

  // Обновляем при каждом изменении вариантов
  document.addEventListener("change", updateButtonAndWarning);
  // убираем обновление при смене цвета (variant:change), слушаем только изменение размера
document.querySelectorAll('select.select__select').forEach(sel => {
  sel.addEventListener('change', updateButtonAndWarning);
});

  document.addEventListener("DOMContentLoaded", updateButtonAndWarning);

  // Shopify иногда пересоздаёт DOM — страховка
  setInterval(updateButtonAndWarning, 120);

  
})();
